import React from 'react';
import styles from './Footer.module.css';
import productBox from '../../assets/images/1814F4C5-6978-4D1A-AB88-B7CBBA53836A.PNG';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.mainProduct}>
          <div className={styles.productDisplay}>
            <img 
              src={productBox} 
              alt="Прогноз 2026" 
              className={styles.productImg} 
            />
          </div>
          <h2 className={styles.productTitle}>Персональный прогноз по 9 Дворцам на 2026 год</h2>
        </div>
        <div className={styles.grid}>
          <div className={styles.column}>
            <h3 className={styles.title}>Контакты</h3>
            <div className={styles.contactItem}>
              <a href="mailto:master@annavision.me" className={styles.contactLink}>
                <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
                master@annavision.me
              </a>
            </div>
            <div className={styles.contactItem}>
              <a href="https://t.me/zlatarich" target="_blank" rel="noopener noreferrer" className={styles.contactLink}>
                <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"/>
                </svg>
                Zlata RICH
              </a>
            </div>
            <div className={styles.contactItem}>
              <a href="https://t.me/AV_personal_shop_bot" target="_blank" rel="noopener noreferrer" className={styles.contactLink}>
                <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/><path d="M12 8l4 4-4 4M8 12h7"/>
                </svg>
                Консьерж-сервис
              </a>
            </div>
          </div>
          <div className={styles.column}>
            <h3 className={styles.title}>Поддержка</h3>
            <p>Мы отвечаем на вопросы в течение 24 часов. Если у вас есть вопросы о прогнозе, процессе заказа или использовании рекомендаций - пишите нам.</p>
          </div>
          <div className={styles.column}>
            <h3 className={styles.title}>Документы</h3>
            <ul className={styles.links}>
              <li><a href="#oferta">Публичная оферта</a></li>
              <li><a href="#privacy">Политика конфиденциальности</a></li>
              <li><a href="#personal">Соглашение на обработку персональных данных</a></li>
            </ul>
          </div>
          <div className={styles.column}>
            <h3 className={styles.title}>О системе 9 Дворцов</h3>
            <p>Система 9 Дворцов - древняя китайская метафизическая система, основанная на расчете персональной энергетической карты. Мы используем ее в сочетании с элементами Ба Цзы для создания максимально точных персональных прогнозов.</p>
          </div>
        </div>
        <div className={styles.videoSection}>
          <div className={styles.videoWrapper}>
            <iframe 
              src="https://youtube.com/embed/_fu77RlR97M" 
              frameborder="0" 
              allowfullscreen
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              title="Пояснение прогноза"
            ></iframe>
          </div>
        </div>
        <div className={styles.copyright}>
          <p>© 2025. Все права защищены. <a href="https://annavision.me/9palaces/oferta/" target="_blank" rel="noopener noreferrer" className={styles.ofertaLink}>Публичная оферта</a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

